<app-home [titre]="title"
          [menu]="menu"
          [anonymous]="false"
          [miniSidenav]="true"
          [darkTheme]="true"
          class="mat-typography"
></app-home>
<span *ngIf="showLoader" class="loading"></span>

<assistant-rag *ngIf="showChatbot()"
  [apiUrl]="baseUrlRag"
  [collection]="'wiki_p8'"
  [askPath]="askPath"  
  history="true"
  [labels]="{
      panelTitle: 'Assistant virtuel Wiki P8',
      panelSubtitle: 'Posez une question sur les pages et documents',
      welcomeHeading: 'Comment puis-je vous aider ?',
      welcomeHint: 'Recherche dans la base documentaire Wiki P8',
      launcherOpen: 'Ouvrir l’assistant',
      launcherClose: 'Fermer l’assistant',
      placeholder: 'Votre question…',
      disclaimer: 'Réponses générées à partir des sources indexées. Vérifiez les documents cités.'
    }"
>

</assistant-rag>

